export type DashboardPageOptions =
  | "Schedules"
  | "LiveMap"
  | "Visitors"
  | "News"
  | "SiteInfo";

export const getDefaultDashboardTab = (
  isOrgPrivacyEnabled: boolean,
  isMobile?: boolean,
  organizationSlug?: string | null,
  hasSelectedEvent?: boolean
): DashboardPageOptions => {
  // Bridgestone launch customization: land on Live Map instead of the usual
  // default. sc-9072. Live Map's tab is hidden while an event is selected
  // (see DashboardStateContext's validTabs), so don't default into it then.
  if (organizationSlug === "bridgestone" && !hasSelectedEvent) return "LiveMap";

  return isMobile
    ? "Schedules"
    : isOrgPrivacyEnabled
      ? "SiteInfo"
      : "Schedules";
};
